import { FC, memo } from 'react';
import { Root, Spinner } from './styles';

export const Preloader: FC = memo(() => (
  <Root>
    <Spinner />
  </Root>
));
